<template>
  <div class="row mt-4">
    <!-- LeftSideBar -->

    <div class="col-lg-9 col-md-7 d-flex flex-column rounded border p-3" style="background-color: white;">
      <div class="d-flex flex-row mb-2 align-items-start form-data">
        <div class=" me-1" style="font-size: 14px; font-weight: 600;">Slug:</div>
        <div v-if="slugEditEnabled" class="">
          <b-form-input v-model="requestSaveElement.slug" :state="slugValidation()" autocomplete="off" class="me-3"
                        type="text" v-bind:class="{
          'form-control': true,
          'is-invalid': !slugValidation(),
        }"/>
          <div class="invalid-feedback">
            Slug should not be empty!
          </div>

        </div>
        <div v-else class="me-1 px-1 py-1">
          /{{ requestSaveElement.slug }}
        </div>

        <a v-if="slugEditEnabled == null || slugEditEnabled == false" class="" href="javascript:void(0)"
           style="padding-inline: 5px; padding-block: 1px;" type="button" @click="slugEditEnabled = true">
          <i class="fa-regular fa-pen-to-square text-primary"></i> Edit
        </a>
        <a v-else href="javascript:void(0)" style="padding-inline: 5px; padding-block: 1px;"
           @click="slugEditEnabled = false">
          <i class="fa-solid fa-xmark text-primary"></i>
          Cancel</a>
      </div>
      <div class="main-section d-flex flex-column" style="display: flex">
        <div class="input-label">Bangla Title <span v-if="banglaValidation" class="text-danger">*</span></div>
        <div class="mb-2">
          <b-form-input v-model="requestSaveElement.title" class="form-control px-3 " placeholder="Add title"
                        style="height: 44px;" v-bind:class="{
          'form-control': true,
          'is-invalid': banglaValidation && !isBanglaTitleValid
        }" v-on:blur="titleBlurred = true"/>
          <div class="invalid-feedback">
            Title should be valid!
          </div>
        </div>

        <div class="input-label">English Title<span v-if="englishValidation" class="text-danger">*</span></div>
        <b-form-input v-model="requestSaveElement.title_en" class="form-control px-3 " placeholder="Add English title"
                      style="height: 44px;"
                      v-bind:class="{ 'form-control': true, 'is-invalid': englishValidation && !isEnglishTitleValid }"
                      v-on:blur="titleBlurred = true"/>
        <div class="invalid-feedback">
          Title should be valid!
        </div>
      </div>

      <div class="input-label mt-3">Post Type</div>
      <select v-model="requestSaveElement.view_type" class="form-control" style="height: 44px">
        <option selected="selected" value="REGULAR">REGULAR</option>
        <option value="LIST">LIST</option>
        <!--        <option value="FORM">FORM</option>-->
      </select>

      <!--! EDITOR  -->
      <div v-if="requestSaveElement.view_type === 'REGULAR'" class="form-group mt-3">
        <div class="d-flex justify-content-between">
          <div class="d-flex justify-content-start mb-2">
            <button class="btn btn-info btn-lg" type="button" @click="showModal = true">Add Media</button>
          </div>
          <div v-if="showModal">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;" tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                            @click="showModal = false"></button>
                  </div>
                  <div class="modal-body">
                    <show-all-media-component/>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                            @click="showModal = false">Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--! Editor  -->
        <div class="input-label">Bangla Content <span v-if="banglaValidation" class="text-danger">*</span></div>
        <Editor @htmlData='getBanglaHtmlContent'></Editor>
        <div class="input-label mt-3">English Content<span v-if="englishValidation" class="text-danger">*</span></div>
        <Editor :is-only-english="true" @htmlData='getEnglishHtmlContent'></Editor>
      </div>

      <div v-else-if="requestSaveElement.view_type === 'LIST'" class="form-group mt-3">
        <div class="input-label">Files</div>
        <b-table :fields="fields" :items="fileObjects" bordered hover responsive>
          <template #table-busy>
            <div class="text-center text-danger my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(index)="row">
            {{ row.index + 1 }}
          </template>
          <template #cell(title_bn)="row">
            <input v-model="row.item.title_bn" :disabled="row.item.saved" class="form-control mt-2"
                   placeholder="Enter Bangla Title"
                   type="text"/>
          </template>
          <template #cell(title_en)="row">
            <input v-model="row.item.title_en" :disabled="row.item.saved" class="form-control mt-2"
              placeholder="Enter English Title" type="text" />
          </template>
          <template #cell(file_publish_date)="row">
            <VueDatePicker v-model="row.item.file_publish_date" :disabled="row.item.saved" :format="'dd-MM-yyyy'"
              :z-index="9999" teleport="body" auto-apply class="mt-2" />
          </template>
          <template #cell(file)="row">
            {{ row.item.file_mapping_names ? row.item.file_mapping_names.join(', ') : '' }}
          </template>
          <template #cell(actions)="row">
            <div class="d-flex flex-row gap-2">
              <button v-if="fileObjects.length > 1 && !row.item.saved" class="btn btn-danger" style="width: 35px"
                      @click="deleteOption(row.index)">
                <span class="fa-solid fa-trash"></span>
              </button>
              <button class="btn btn-primary d-flex align-items-center justify-content-center"
                      style="width: 35px" type="button"
                      @click="showModalPartners = true;selectedItemIndexForMedia = row.index;">
                <div class="fa-solid fa-plus"></div>
              </button>
            </div>
            <div class="d-flex justify-content-start">
              <div v-if="showModalPartners">
                <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                     class="modal fade show" role="dialog" style="display: block;"
                     tabindex="-1">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                                type="button" @click="showModalPartners = false"></button>
                      </div>
                      <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                        <selectable-media-component :allow-pdf-select="true"
                                                    :dont-show-image="false"
                                                    :fetch-image-ids="row.item.media_file_id_list"
                                                    @imgList="getImages"/>
                      </div>
                      <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        @click="saveImage">Ok</button> -->
                        <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                                @click="showModalPartners = false">Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-table>
        <button class="btn btn-primary" @click="addNewOption">Add File</button>
      </div>


      <!--! TABLE  -->

    </div>
    <!-- RightSideBar -->
    <div class="col-lg-3 col-md-5 ">
      <div class="row">
        <div class="col-md-12 mb-5">
          <div class="side-bar d-flex flex-column w-100">
            <div class="active-options"></div>
            <!-- Publish -->
            <div class="publish mb-3" style="background-color:white">
              <div class="d-flex flex-column border p-3 h-100">
                <div class="row align-items-center px-2">
                  <div class="col-md-6">
                    <h5><b>Publish</b></h5>
                  </div>
                </div>
                <hr style="height: 0%;"/>
                <!-- publish time  -->
                <div class="d-flex flex-row my-1" style="display: flex;flex-wrap: wrap;">
                  <div class="d-flex align-self-center">
                    <i class="fa-solid fa-calendar-days icon-publish"></i>
                  </div>
                  <div class="text-sx align-self-center">Publish:</div>
                  <div v-if="requestSaveElement.publish_time == null"
                       class="text-sx align-self-center text-selected ms-1 me-auto" style="">
                    immediately
                  </div>
                  <div v-else class="text-sx align-self-center text-selected ms-1 me-auto" style="">
                    {{ requestSaveElement.publish_time_format }}
                  </div>
                  <button aria-controls="calendarVisibility" aria-expanded="false"
                          class="btn x-small-btn border border-primary text-primary align-self-center mx-1 edit-button"
                          data-bs-toggle="collapse" href="#calendarVisibility" role="button" @click="printDate">
                    Edit
                  </button>
                </div>
                <div id="calendarVisibility" class="collapse my-2">
                  <!-- <input type="datetime-local" id="birthdaytime" name="birthdaytime"
                      class="form-control form-control-sm" v-model="requestSaveElement.publish_time"> -->
                  <VueDatePicker ref="datepicker" v-model="requestSaveElement.publish_time" :format="publishTimeFormat"
                                 :format-locale="locale" auto-apply>
                  </VueDatePicker>
                </div>
                <!-- expiry time  -->
                <div class="d-flex flex-row my-1" style="display: flex;flex-wrap: wrap;">
                  <div class="d-flex align-self-center">
                    <i class="fa-solid fa-calendar-days icon-publish"></i>
                  </div>
                  <div class="text-sx align-self-center">Expiry:</div>
                  <div v-if="requestSaveElement.expiry_time == null"
                       class="text-sx align-self-center text-selected ms-1 me-auto" style="">
                    None
                  </div>
                  <div v-else class="text-sx align-self-center text-selected ms-1 me-auto" style="">
                    {{ requestSaveElement.expiry_time_format }}
                  </div>
                  <button aria-controls="expiryCalendarVisibility" aria-expanded="false"
                          class="btn x-small-btn border border-primary text-primary align-self-center mx-1 edit-button"
                          data-bs-toggle="collapse" href="#expiryCalendarVisibility" role="button">
                    Edit
                  </button>
                </div>
                <div id="expiryCalendarVisibility" class="collapse my-2">
                  <!-- <input type="datetime-local" id="birthdaytime" name="birthdaytime"
                      class="form-control form-control-sm" v-model="requestSaveElement.expiry_time"> -->
                  <VueDatePicker v-model="requestSaveElement.expiry_time" :format="expiryTimeFormat"
                                 :format-locale="locale" :min-date="requestSaveElement.publish_time" auto-apply/>
                </div>
                <hr class=" mx-0"/>
                <div v-if="permissions.ADD_CONTENT === 'Y' || permissions.PUBLISH_CONTENT === 'Y'"
                     class="d-flex justify-content-between flex-row">
                  <button v-if="permissions.ADD_CONTENT === 'Y'" class="btn align-self-center"
                          style="background-color: rgb(58, 4, 123); color: white;" @click="submit('N')">
                    Save Draft
                  </button>
                  <button v-if="permissions.PUBLISH_CONTENT === 'Y'" class="btn btn-sm btn-primary"
                          @click="submit('Y')">Publish
                  </button>
                </div>
                <div v-else class="text-danger">
                  You don't have the permission to create.
                </div>

              </div>
            </div>

            <!-- Categories -->
            <div class="categories" style="background-color:white">
              <div class="d-flex flex-column border px-2 py-2 h-100">
                <h5 class="mx-2 mt-2"><b>Categories</b></h5>
                <hr/>
                <div id="myTabContent" class="my-2">
                  <div id="allCategories" style="max-height: 300px; overflow-y: scroll;">
                    <ul class="text-dark" style="list-style-type: none;">
                      <li v-for="(info, index) in categories" :key="index" class="popular-category">
                        <label class="selectit" style="font-weight: bold;">
                          <input :id="info.name" v-model="requestSaveElement.sub_category_ids" :value="info.id"
                                 class="checkbox-input" type="checkbox"/>
                          {{ info.name }}
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
                <hr class="my-2 mx-0"/>
                <!-- <router-link to="/post/categories">
                    <div class="btn-sm" role="button" v-if="permissions.UPDATE_CONTENT == 'Y'">
                        <span aria-hidden="true">+ Add New Category</span>
                    </div>
                </router-link> -->
              </div>
            </div>
            <!-- designation  -->
            <div v-if="category_id == 8" class="rounded p-3 border mt-3 " style="background-color: white;">
              <div class="main-section d-flex flex-column" style="display: flex">
                <div class="input-label"> Designation <span class="text-danger">*</span></div>
                <b-form-input v-model="requestSaveElement.designation" class="form-control px-3 mb-2"
                              placeholder="Add Designation" style="height: 34px;"/>
                <div class="input-label"> Designation English</div>
                <input v-model="requestSaveElement.designation_en" class="form-control px-3 mb-2"
                       placeholder="Add English Designation" style="height: 34px;" type="text"/>
                <div class="input-label"> Designation Details <span class="text-danger">*</span></div>
                <b-form-input v-model="requestSaveElement.designation_details
          " class="form-control px-3 mb-2" placeholder="Add Designation" style="height: 34px;"/>
                <div class="input-label"> Designation Details English</div>
                <input v-model="requestSaveElement.designation_details_en" class="form-control px-3 mb-2"
                       placeholder="Add English Designation" style="height: 34px;" type="text"/>
                <div class="input-label"> Designation Weight <span class="text-danger">*</span></div>
                <input v-model="requestSaveElement.designation_weight" class="form-control px-3 mb-2"
                       placeholder="Add Designation Weight" style="height: 34px;" type="number"/>
              </div>
            </div>
            <!--            meta info-->
            <div class="mt-3">
              <div class="d-flex flex-column border rounded px-3 pt-3 pb-4 h-100" style="background-color:white">
                <div class="row align-items-center px-2">
                  <div class="col-md-6">
                    <h5><b>SEO Info</b></h5>
                  </div>
                </div>
                <hr style="height: 0%;"/>
                <div class="main-section d-flex flex-column" style="display: flex">
                  <div class="input-label">Meta Title</div>
                  <div class="mb-2">
                    <b-form-input v-model="requestSaveElement.meta_title" class="form-control px-3 "
                                  placeholder="Add Meta Title" style="height: 32px;"/>
                  </div>
                  <div class="input-label"> Meta Description</div>
                  <textarea v-model="requestSaveElement.meta_description" class="form-control px-3 mb-2"
                            placeholder="Add Meta Description" rows="3" type="text"/>
                  <div class="input-label"> Meta Keywords</div>
                  <div class="d-flex flex-row" style="align-items: center">
                    <input v-model="metaKeyword" class="form-control px-3" placeholder="Add Meta Keywords"
                           style="height: 32px;" type="text" @keyup.enter="addMetaKeyword"/>
                    <button class="ms-2 btn btn-sm btn-primary" style="height: 32px" type="button"
                            @click="addMetaKeyword">
                      Add
                    </button>
                  </div>
                  <div class="d-flex flex-row mt-1 flex-wrap row-gap-1">
                    <div v-for="(keyword, index) in metaKeywordsList" :key="index"
                         class="rounded border px-2 py-1 me-1 d-flex flex-row" style="align-items: center;">
                      <div style="font-size: 12px"> {{ keyword }}</div>
                      <div class="btn" style="margin: 0;padding: 1px; " @click="removeKeyword(keyword)">
                        <i class="fa-solid fa-xmark text-danger"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- image  -->
            <div class="my-3 rounded p-3 border" style="background-color: white;">
              <div class="input-label mb-2">Featured Image</div>
              <figure v-if="requestSaveElement.image_id != null" class="figure mb-2"
                      style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #aeacac;border-width: 0.5px;border-style: solid;">
                <div v-if="requestSaveElement.image_id != null">
                  <img :src="imageBasePath + requestSaveElement.image_url" style="width: 100%;aspect-ratio : 1 / 1;">
                </div>
              </figure>
              <div class="d-flex justify-content-start">
                <button class="btn btn-info" style="width: 100%;" @click="showModalLogo = true">Add
                  Image
                </button>
              </div>
              <div v-if="showModalLogo">
                <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                     class="modal fade show" role="dialog" style="display: block;" tabindex="-1">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                                @click="showModalLogo = false"></button>
                      </div>
                      <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                        <select-logo @logoImg="getImageData"/>
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-primary" data-bs-dismiss="modal" type="button"
                                @click="showModalLogo = false">Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-md-12 mb-5">
          <div class="side-bar d-flex flex-column w-100">
            <div class="active-options"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import showAllMedia from '@/components/Media/ShowAllMedia.vue';
import subcategoryService from "@/services/subCategory.service"
import postService from "@/services/post.service";
import Editor from "@/components/Editor";
import selectLogo from '@/components/Media/SelectLogo.vue';
import Config from '@/config/index';
import VueDatePicker from '@vuepic/vue-datepicker';
import moment from "moment";
import '@vuepic/vue-datepicker/dist/main.css'
import {format_date_ddmmmyyyy} from "@/helpers";
import {formatInTimeZone} from "date-fns-tz";
import {enUS} from 'date-fns/locale';
import selectableMedia from "@/components/Media/SelectableMedia.vue";

export default {
  name: "AddElement",
  components: {
    "selectable-media-component": selectableMedia,
    "show-all-media-component": showAllMedia,
    Editor,
    "select-logo": selectLogo,
    VueDatePicker,
  },
  computed: {
    title() {
      return this.requestSaveElement.title;
    }
  },
  watch: {
    title() {
      this.requestSaveElement.slug = this.requestSaveElement.title.trim().replaceAll(' ', '-').replaceAll('/', '-')
          .replace(/[&\\#,+()[/;^!@\]$~%.।'":*?<>{}]/g, '').toLocaleLowerCase();
      this.requestSaveElement.extension_url = this.requestSaveElement.slug;
    }
  },
  created() {
    this.locale = enUS;
    const eng = localStorage.getItem('english_validation');
    const bang = localStorage.getItem('bangla_validation');
    this.englishValidation = eng === 'Y'
    this.banglaValidation = bang === 'Y'

    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.imageBasePath = Config.apiFileBasePath;
    this.getCategories();
  },
  props: ['category_id'],
  data() {
    return {
      isBanglaTitleValid: true,
      isEnglishTitleValid: true,
      showModalPartners: false,
      permissions: {},
      slugBlurred: false,
      titleBlurred: false,
      englishValidation: false,
      banglaValidation: false,
      showModalLogo: false,
      imageBasePath: null,
      showModal: false,
      categories: [],
      slugEditEnabled: null,
      requestSaveElement: {
        category_id: this.category_id,
        sub_category_ids: [],
        title: "",
        title_en: "",
        base_url: window["baseUrl"],
        slug: "",
        body: "",
        body_en: "",
        public_yn: "Y",
        publish_time: null,
        expiry_time: null,
        // 2023-12-26T06:42:38.532Z
        meta_title: null,
        meta_description: null,
        meta_keywords: null,
        view_type: 'REGULAR',
      },
      metaKeywordsList: [],
      selectedItemIndexForMedia: 0,
      metaKeyword: null,
      locale: null,
      fileObjects: [
        {
          file_mapping_id: null,
          title_en: "",
          title_bn: "",
          file_publish_date: null,
          saved: false
        },
      ],
      fields: [
        {
          key: 'index', label: '#',
          thStyle: {width: "3%"}, tdClass: "px-2", thClass: "px-2",
        },
        {
          key: 'title_bn', label: 'Bangla Title',
          thStyle: {width: "22%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'title_en', label: 'English Title',
          thStyle: {width: "22%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'file_publish_date', label: 'Publish Date',
          thStyle: { width: "22%" }, tdClass: "px-2", thClass: "px-3",
        },
        {
          key: 'file', label: 'File', sortable: false,
          thStyle: {width: "21%"}, tdClass: "px-3 pt-2", thClass: "px-3",
        },
        {
          key: 'actions', label: 'Actions', tdClass: "px-3 pt-2",
          thStyle: {width: "8%"},
        },
      ],
    };
  },

  methods: {
    addNewOption() {
      this.fileObjects.push({
        option_text: ''
      });
    },
    getImages(data) {
      this.fileObjects[this.selectedItemIndexForMedia].media_file_id_list = [];
      this.fileObjects[this.selectedItemIndexForMedia].file_mapping_names = [];
      const parsedData = JSON.parse(data);
      parsedData.forEach((element) => {
        this.fileObjects[this.selectedItemIndexForMedia].media_file_id_list.push(element[0].media_file_id);
        this.fileObjects[this.selectedItemIndexForMedia].file_mapping_names.push(element[0].media_file_name);
        // this.headerData.header_slide_images.push(
        //     {
        //       'image': element[0].media_file_id,
        //       'image_url': element[0].file_path,
        //     }
        // );
        // this.headerData.slideBarImageIds.push(element[0].media_file_id);
      });
    },
    deleteOption(index) {
      this.fileObjects.splice(index, 1);
      this.files.splice(index, 1);
    },
    removeKeyword(keyword) {
      if (this.metaKeywordsList.includes(keyword)) {
        const index = this.metaKeywordsList.indexOf(keyword);
        if (index > -1) {
          this.metaKeywordsList.splice(index, 1);
        }
      }
    },
    addMetaKeyword() {
      const keyword = this.metaKeyword;
      if (keyword != null && keyword !== "" && !this.metaKeywordsList.includes(keyword)) {
        this.metaKeywordsList.push(keyword);
      }
      this.metaKeyword = null;
    },
    formatDateDDMMMYYYY(value) {
      return format_date_ddmmmyyyy(value);
    },
    publishTimeFormat(date) {
      const pad = (n) => (n < 10 ? '0' + n : n);

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());

      let hours = date.getHours();
      const minutes = pad(date.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedHours = pad(hours);

      return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
    },
    expiryTimeFormat(date) {
      const pad = (n) => (n < 10 ? '0' + n : n);

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());

      let hours = date.getHours();
      const minutes = pad(date.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedHours = pad(hours);

      return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
    },
    getBanglaHtmlContent(data) {
      this.requestSaveElement.body = data;
    },
    getEnglishHtmlContent(data) {
      this.requestSaveElement.body_en = data;
    },

    async getCategories() {
      this.loading = true;
      const response = await subcategoryService.getSubCategoriesByCategoryId(this.category_id);
      this.loading = false;

      if (response.data) {
        this.categories = response.data;
      }
    },
    clearSubmit() {
      this.requestSaveElement = {
        category_id: this.category_id,
        sub_category_ids: [],
        title: "",
        title_en: "",
        base_url: window["baseUrl"],
        slug: "",
        body: "",
        body_en: "",
        public_yn: "Y",
        publish_time: null,
        expiry_time: null,
        meta_title: null,
        meta_description: null,
        meta_keywords: null,
        view_type: 'REGULAR',
      };
      this.metaKeywordsList = [];
      this.metaKeyword = null;
    },
    getImageData(data) {
      this.requestSaveElement.image_url = data.file_path;
      this.requestSaveElement.image_id = data.media_file_id;
    },
    async submit(public_yn) {
      if (!this.checkValidation()) {
        return;
      }
      if (this.requestSaveElement.expiry_time && moment(this.requestSaveElement.expiry_time).isBefore(this.requestSaveElement.publish_time)) {
        notify({
          type: "error",
          title: "New Post",
          text: "Expiry time can't be earlier than publish time!",
        });
        return;
      }

      if (this.requestSaveElement.publish_time != null && this.requestSaveElement.publish_time !== '') {
        this.requestSaveElement.publish_time = formatInTimeZone(new Date(this.requestSaveElement.publish_time), 'Asia/Dhaka', "yyyy-MM-dd'T'HH:mm");
      }

      if (this.requestSaveElement.expiry_time != null && this.requestSaveElement.expiry_time !== '') {
        this.requestSaveElement.expiry_time = formatInTimeZone(new Date(this.requestSaveElement.expiry_time), 'Asia/Dhaka', "yyyy-MM-dd'T'HH:mm");
      }

      this.loading = true;
      this.requestSaveElement.category_id = this.category_id;
      if (public_yn) {
        this.requestSaveElement.public_yn = public_yn;
      }
      let payLoad = {
        base_url: this.requestSaveElement.base_url,
        body: this.requestSaveElement.body,
        body_en: this.requestSaveElement.body_en,
        category_id: this.requestSaveElement.category_id,
        expiry_time: this.requestSaveElement.expiry_time,
        extension_url: this.requestSaveElement.extension_url,
        public_yn: this.requestSaveElement.public_yn,
        publish_time: this.requestSaveElement.publish_time,
        slug: this.requestSaveElement.slug,
        title: this.requestSaveElement.title,
        title_en: this.requestSaveElement.title_en,
        sub_category_ids: this.requestSaveElement.sub_category_ids,
        designation: this.requestSaveElement.designation,
        designation_en: this.requestSaveElement.designation_en,
        designation_details: this.requestSaveElement.designation_details,
        designation_details_en: this.requestSaveElement.designation_details_en,
        designation_weight: this.requestSaveElement.designation_weight,
        image_id: this.requestSaveElement.image_id,
        meta_title: this.requestSaveElement.meta_title,
        meta_keywords: this.metaKeywordsList.toString(),
        meta_description: this.requestSaveElement.meta_description,
        fileMappingModels: this.fileObjects,
        view_type: this.requestSaveElement.view_type
      };
      let response;
      try {
        response = await postService.saveNewPost(payLoad);
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "New Post",
          text: error,
        });
        return;
      }
      // let self = this;
      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "New Post",
            text: response.data.message,
          });
          this.clearSubmit();
          // self.$router.go(-1);
        } else {
          notify({
            type: "error",
            title: "New Post",
            text: response.data.message,
          });
        }
      }
    },
    titleValidation() {
      this.isBanglaTitleValid = true;
      this.isEnglishTitleValid = true;
      let result = true;

      const banglaRegex = /[\u0980-\u09FF]/;
      const testResult = banglaRegex.test(this.requestSaveElement.title_en);
      if (this.requestSaveElement.title === "" && this.banglaValidation) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Required Bangla Title should not be empty!",
        });
        this.isBanglaTitleValid = false;
        result = false;
      }
      if (this.requestSaveElement.title_en === "" && this.englishValidation) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Required English Title should not be empty!",
        });
        this.isEnglishTitleValid = false;
        result = false;
      } else if (testResult) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Remove bangla words in english title !",
        });
        this.isEnglishTitleValid = false;
        result = false;
      } else {
        this.isEnglishTitleValid = true;
        this.isBanglaTitleValid = true;
        result = true;
      }
      return result;

    },
    bodyValidation() {
      // const banglaRegex = /[\u0980-\u09FF]/;
      // const testResult = banglaRegex.test(this.requestSaveElement.body_en);
      if (this.requestSaveElement.view_type !== 'LIST') {
        if (this.requestSaveElement.body === "" && this.banglaValidation) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Bangla content should not be empty!",
          });
          return false;
        } else if (this.requestSaveElement.body_en === "" && this.englishValidation) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "English content should not be empty!",
          });
          return false;
        } 
        // else if (testResult) {
        //   notify({
        //     type: "error",
        //     title: "Wrong Input",
        //     text: "Remove bangla words in english content!",
        //   });
        //   return false;
        // } 
        else {
          return true;
        }
      }
      return true;

    },
    slugValidation() {
      if (this.requestSaveElement.slug != null) {
        if (this.requestSaveElement.slug.length == 0) {
          return false;
        }
        return true;

      } else {
        return false;
      }
    },
    checkValidation() {
      // if (!this.titleValidation()) {
      //   return false;
      // }
      if (!this.slugValidation()) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Slug should not be empty!",
        });
        return false;
      }
      if (!this.bodyValidation()) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.btn {
  height: 32px;
}

.text-selected {
  font-size: 12px;
  font-weight: 700;
  color: #605e5e;
}


.icon-publish {
  height: 15px;
  width: 15px;
  padding-right: 4px;
  color: #9b9292;

}

.text-radio {
  font-size: 13px;
}

.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 80vh;
  overflow-y: auto;
}

.input-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  margin-left: 2px;
}

.edit-button {
  padding: 2px 10px;
}

.metaKeyword {
  border: none;
}

.metaKeyword:hover {
  border: grey;
}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(207, 206, 206);
  border-radius: 10px;
}


/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(186, 182, 182);
  border-radius: 10px;
}
</style>
